var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { connect } from "react-redux";
import Loader from "../Loader";
import Axios from "axios";
import { Link } from "react-router-dom";
import { defineMessages, FormattedMessage } from "react-intl";
import CheckItem from "./CheckItem";
var messages = defineMessages({
    check_opexCheck_title: {
        id: "check.opexCheck_title",
        defaultMessage: "«Opex» checks"
    },
    check_checks_not_found: {
        id: "check.checks_not_found",
        defineMessages: "Checks not found"
    },
    check_active: {
        id: "active.check_active",
        defaultMessage: "Active"
    },
    check_used: {
        id: "check.check_used",
        defaultMessage: "Used"
    }
});
var BironexChecks = /** @class */ (function (_super) {
    __extends(BironexChecks, _super);
    function BironexChecks() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            data: null,
            error: null,
            active: true,
            isLoading: false
        };
        _this.fetchRates = function () {
            Axios.get("/fetch-usdt-rates").then(function (_a) {
                var data = _a.data;
                _this.setState({ curse: data });
            });
        };
        _this.fetchChecks = function () {
            _this.setState({ isLoading: true });
            Axios.post("/fetch-usdt-status", {
                requisite: _this.props.phone.replace(/\D/gi, "")
            })
                .then(function (_a) {
                var data = _a.data;
                _this.setState({ data: data, isLoading: false });
            })
                .catch(function (error) {
                _this.setState({ error: error, isLoading: false });
            });
        };
        _this.onClickUsing = function () {
            _this.setState({ active: false });
        };
        _this.onActiveClick = function () {
            _this.setState({ active: true });
        };
        return _this;
    }
    BironexChecks.prototype.componentDidMount = function () {
        this.fetchRates();
        this.fetchChecks();
    };
    BironexChecks.prototype.render = function () {
        var _a = this.state, data = _a.data, curse = _a.curse, error = _a.error, isLoading = _a.isLoading, active = _a.active;
        var report = active ? getActiveChecks(data) : getUsedChecks(data);
        if (isLoading) {
            return _jsx(Loader, {});
        }
        if (error) {
            return _jsxs("div", { children: ["Error: ", error.message] });
        }
        return (_jsxs("div", __assign({ className: "opex-checks" }, { children: [_jsx("div", __assign({ className: "opex-checks__title" }, { children: _jsxs("div", __assign({ className: "new-join__head" }, { children: [_jsx(Link, { className: "new-join__back", to: "/" }), "USD\u20AE"] })) })), _jsxs("div", __assign({ className: "history__filter" }, { children: [_jsx("button", __assign({ className: active
                                ? "history__filter__item history__filter__item--active"
                                : "history__filter__item", onClick: this.onActiveClick }, { children: _jsx(FormattedMessage, __assign({}, messages.check_active)) })), _jsx("button", __assign({ className: !active
                                ? "history__filter__item history__filter__item--active"
                                : "history__filter__item", onClick: this.onClickUsing }, { children: _jsx(FormattedMessage, __assign({}, messages.check_used)) }))] })), !isLoading && report.length === 0 && (_jsx("div", __assign({ className: "opex-checks__not-found" }, { children: _jsx("div", __assign({ className: "opex-check" }, { children: _jsx(FormattedMessage, __assign({}, messages.check_checks_not_found)) })) }))), report.map(function (receipt) {
                    return _jsx(CheckItem, { receipt: receipt, curse: curse }, receipt.Pin);
                })] })));
    };
    return BironexChecks;
}(React.Component));
function getActiveChecks(report) {
    var filtered = [];
    for (var key in report) {
        if (report.hasOwnProperty(key)) {
            if (report[key].state === 0) {
                filtered.push(report[key]);
            }
        }
    }
    return filtered;
}
function getUsedChecks(report) {
    var filtered = [];
    for (var key in report) {
        if (report.hasOwnProperty(key)) {
            if (report[key].state !== 0 && filtered.length < 10) {
                filtered.push(report[key]);
            }
        }
    }
    return filtered;
}
var withAuth = function (_a) {
    var profile = _a.profile;
    var user = profile.gambler || {};
    if (profile.fetching) {
        return _jsx(Loader, {});
    }
    if (user.phoneConfirmed) {
        return _jsx(BironexChecks, __assign({}, user));
    }
    return _jsx("h1", { children: "\u0417\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430!" });
};
export default connect(function (s) { return ({
    profile: s.application.get("profile")
}); })(withAuth);



// WEBPACK FOOTER //
// ./src/components/bironex-checks/index.jsx